import { useEffect, useRef } from 'react';
import { useMyConsumerPersona } from '@rabbit/data/portal';
import { OliveHoldingRegistrationFormData } from '@rabbit/elements/shared-types';
import { useOliveAPI } from '../api/useOliveAPI';

export function useCreateHoldingFromVendable(vendableDocid: string) {
  const { registerConsumerHolding } = useOliveAPI();

  // Get the consumer persona
  const consumerPersona = useMyConsumerPersona();
  // Never throw during render: persona/identity may be created async (e.g. magic-link login).
  // Instead, we'll validate at call-time.
  const consumerPersonaRef = useRef(consumerPersona);
  useEffect(() => {
    consumerPersonaRef.current = consumerPersona;
  }, [
    consumerPersona.personaId,
    consumerPersona.data.consumer_private,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (consumerPersona as any).isFetched,
  ]);

  async function createUserHolding(formData: OliveHoldingRegistrationFormData) {
    if (!vendableDocid) {
      throw new Error('Vendable docid is required');
    }

    const cp = consumerPersonaRef.current;
    if (!cp?.personaId || !cp?.data?.consumer_private) {
      // This usually means the user hasn't completed initial account setup yet.
      throw new Error('Consumer persona not found');
    }

    const holdingId = await registerConsumerHolding({
      vendableDocid,
      formData,
    });
    return holdingId;
  }

  return createUserHolding;
}
